import Controller from '../abstracts/Controller';
import 'scss-templates/t-contactus.scss';

export default class ContactUsController extends Controller {
  static get COMPONENTS() {
    return [
      'CollapseComponent',
      'ContactUsComponent',
      'DatePickerComponent',
      'RecaptchaComponent',
      'NewPrivacyComponent',
    ];
  }

}
